import React from "react";

// CAMO logo: word mark with Saturn-inspired orbital ring above
export const Logo = ({ size = "md", showRing = true, className = "" }) => {
  const sizes = {
    sm: { text: "text-2xl", ring: "w-16 h-4", planet: "w-2 h-2" },
    md: { text: "text-4xl md:text-5xl", ring: "w-24 h-6", planet: "w-3 h-3" },
    lg: { text: "text-6xl md:text-7xl lg:text-8xl", ring: "w-36 h-9", planet: "w-4 h-4" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`inline-flex flex-col items-center select-none ${className}`} data-testid="camo-logo">
      {showRing && (
        <div className="relative mb-2 md:mb-3" aria-hidden>
          <div
            className={`${s.ring} border border-white/80 rounded-[50%]`}
            style={{ transform: "rotateX(72deg) rotateZ(-12deg)" }}
          />
          <div
            className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 ${s.planet} rounded-full bg-white`}
          />
        </div>
      )}
      <span
        className={`font-display font-light tracking-[0.35em] uppercase ${s.text} text-white leading-none`}
      >
        CAMO
      </span>
    </div>
  );
};

export default Logo;
